import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import { Theme, useTheme } from "@mui/material/styles";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export const CurbPassInactive: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ height: "100%", bgcolor: "background.paper", py: { xs: 3.5, sm: 7.5 } }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" color="textSecondary">
            <span style={{ color: theme.palette.primary.main }}>CurbPass</span> is not active in your community
          </Typography>
        </Box>
        <Box sx={{ mb: 5 }}>
          <Typography variant="h5">What is CurbPass?</Typography>
          <Typography variant="body1">
            CurbPass is a fully automated payment method that gives drivers access to Smart Curbs and Smart Loading
            Zones in cities across the United States.
            <br />
            <br />
            It is the first fully automated payment method used to park at the curb and allows drivers to minimize
            unnecessary time spent messing with mobile payment apps and/or meters when paying for parking. Drivers with
            CurbPass are only charged by the minute, so you never need to pay for time you do not use.
          </Typography>
        </Box>
        <Box
          sx={{
            mb: 5.5,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 2, sm: 8 },
          }}
        >
          <Typography variant="h5">Metrics Across Cities</Typography>
          <Stack direction="row" spacing={{ xs: 3, sm: 12 }} sx={{ width: { xs: "100%", sm: "auto" } }}>
            <Metric title="Park Dwell Times" value="23%" variant="down" />
            <Metric title="Parking Turnover" value="41%" variant="up" />
            <Metric title="Parking Revenue Generated" value="349%" variant="up" />
          </Stack>
        </Box>
        <Box>
          <Typography variant="h4">
            Ready to automate payment with <span style={{ color: theme.palette.primary.main }}>CurbPass</span>?
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const Metric: React.FC<MetricProps> = ({ title, value, variant }) => {
  const ArrowIcon = variant === "up" ? ArrowUpwardIcon : ArrowDownwardIcon;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <Box display="flex" alignItems="center" gap={0.5}>
        <ArrowIcon color={variant === "up" ? "success" : "error"} style={{ fontSize: "28px" }} />
        <Typography
          sx={{ color: (theme: Theme) => (variant === "up" ? theme.palette.success.main : theme.palette.error.main) }}
          variant="h5"
        >
          {value}
        </Typography>
      </Box>
      <Typography variant="caption">{title}</Typography>
    </Box>
  );
};

interface MetricProps {
  title: string;
  value: string;
  variant: "up" | "down";
}

export default CurbPassInactive;
